import hexToRgba from "@eisinc/XDL/Utilities/hexToRgba";
import getContrastColor from "@insite/mobius/utilities/getContrastColor";

export default (path = "", alpha = 1) => {
    return (props: any = {}) => hexToRgba(getContrastColor(path, props.theme), alpha);
};
